import React, { useState } from 'react';
import { Button } from 'edozvola-frontend-lib/dist/ui';
import CaseConstructionLegalityDocumentsTable from 'app/edozvola/cases/case-construction-legality/documents/case-construction-legality-documents-table';
import CaseConstructionLegalityDocumentsAddForm from 'app/edozvola/cases/case-construction-legality/documents/case-construction-legality-documents-add-form';
import { getCaseContext } from 'app/shared/util/context-util';

export interface ICaseConstructionLegalityDocumentsProps {
  addDocumentDisabled: boolean;
}

const CaseConstructionLegalityDocuments = (props: ICaseConstructionLegalityDocumentsProps) => {
  const [caseConstructionLegalityDocument, setCaseConstructionLegalityDocument] = useState<string | null>(null);
  const { sidebarItemPair } = getCaseContext();

  return (
    <>
      <div className={'d-flex justify-content-between flex-row-reverse'}>
        {!sidebarItemPair.readOnly && (
          <Button
            label="Dodaj akt"
            color={'info'}
            size="lg"
            prependIcon={'plus'}
            disabled={props.addDocumentDisabled}
            onClick={() => setCaseConstructionLegalityDocument('')}
          />
        )}
      </div>
      <div className={'mt-3'}>
        <CaseConstructionLegalityDocumentsTable
          onRowClick={(idConstructionLegalityDocumentMap: string) => setCaseConstructionLegalityDocument(idConstructionLegalityDocumentMap)}
          editConstructionLegalityDocumentDisabled={props.addDocumentDisabled}
        />
      </div>
      {caseConstructionLegalityDocument !== null && (
        <CaseConstructionLegalityDocumentsAddForm
          onCloseCallback={() => setCaseConstructionLegalityDocument(null)}
          idConstructionLegalityDocumentMap={caseConstructionLegalityDocument}
        />
      )}
    </>
  );
};

export default CaseConstructionLegalityDocuments;
